import { render, staticRenderFns } from "./reportNeed.vue?vue&type=template&id=5e306740&scoped=true&"
import script from "./reportNeed.vue?vue&type=script&lang=js&"
export * from "./reportNeed.vue?vue&type=script&lang=js&"
import style0 from "./reportNeed.vue?vue&type=style&index=0&id=5e306740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e306740",
  null
  
)

export default component.exports